import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_EVENTO } from '../../data.const';
import {
  retrieveEventoListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteEventoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_EVENTO),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    // tap(p => console.log(`[epic ${DELETE_EVENTO}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ eventoLoader: true })),
        defer(() =>
          from(
            request({ path: `evento`, method: httpMethods.DELETE, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            // tap(p => console.log(`[epic ${DELETE_EVENTO}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(() => of(retrieveEventoListAction(listBody))),
            catchError(err => {
              console.error(`[epic ${DELETE_EVENTO}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ eventoLoader: false }))
      );
    })
  );

export default deleteEventoEpic;
